import { Chip, styled } from '@mui/material'

const MultiLineChip = styled(Chip)(() => ({
  height: 'auto',
  [`.MuiChip-label`]: {
    display: 'block',
    whiteSpace: 'pre-line', // Allows \n to render as a new line
    textAlign: 'center',
  },
}))

export default MultiLineChip
